/* Marine Collagen PDP (AUVRA-layout replica) — bundle tiers, refill checkbox,
   cart, accordions, reviews pager, reason expanders, sticky bar.
   No Liquid here: money format + variant id arrive via data-attributes. */
(function(){
  var root = document.querySelector('[data-co]');
  if(!root) return;

  /* ---- money ---------------------------------------------------------- */
  var sample = root.dataset.moneySample || '$1.00';
  var sym = sample.replace(/[0-9.,\s]/g, '');
  function money(cents){ return sym + (cents / 100).toFixed(2); }

  /* ---- tiers: pay n, receive QTY[n] ----------------------------------- */
  var unit = parseInt(root.dataset.unitCents, 10) || 0;
  var variantId = root.dataset.variant;
  var QTY = {1:1, 2:3, 3:5};
  var tier = 1;                       /* reference defaults to Buy One */

  var atcPrice = root.querySelector('[data-co-atc-price]');
  function paint(){
    root.querySelectorAll('[data-co-tier]').forEach(function(b){
      b.classList.toggle('is-on', parseInt(b.dataset.coTier, 10) === tier);
    });
    if(atcPrice) atcPrice.textContent = money(unit * tier);
  }
  root.querySelectorAll('[data-co-tier]').forEach(function(b){
    b.addEventListener('click', function(){ tier = parseInt(b.dataset.coTier, 10); paint(); });
  });

  var refill = root.querySelector('[data-co-refill]');
  if(refill) refill.addEventListener('click', function(){ refill.classList.toggle('is-on'); });

  function addToCart(){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: QTY[tier] })
    }).then(function(r){
      if(!r.ok) throw new Error('cart');
      window.themeGoToCheckout();
    }).catch(function(){
      window.location.href = '/cart/add?id=' + variantId + '&quantity=' + QTY[tier];
    });
  }
  root.querySelectorAll('[data-co-add]').forEach(function(b){ b.addEventListener('click', addToCart); });

  /* ---- gallery --------------------------------------------------------- */
  var stage = root.querySelector('[data-co-stage]');
  root.querySelectorAll('[data-co-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      root.querySelectorAll('[data-co-thumb]').forEach(function(o){ o.classList.remove('is-on'); });
      t.classList.add('is-on');
      if(stage) stage.src = t.dataset.coThumb;
    });
  });

  /* ---- accordions (description, FAQ) ----------------------------------- */
  root.querySelectorAll('[data-co-acc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      btn.closest('[data-co-acc-item]').classList.toggle('is-open');
    });
  });

  /* ---- 5-reasons expanders ---------------------------------------------- */
  root.querySelectorAll('[data-co-more]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var card = btn.closest('.rev-co__reason');
      card.classList.toggle('is-open');
      btn.textContent = card.classList.contains('is-open') ? '–' : '+';
    });
  });

  /* ---- review pager (2 pages of 3) --------------------------------------- */
  var pages = [];
  root.querySelectorAll('[data-co-rev-page]').forEach(function(p){ pages.push(p); });
  var dotsEl = root.querySelector('[data-co-rev-dots]');
  if(pages.length && dotsEl){
    var cur = 0;
    function paintRevs(){
      pages.forEach(function(p, i){ p.style.display = i === cur ? '' : 'none'; });
      var html = '';
      for(var i = 0; i < pages.length; i++) html += '<i' + (i === cur ? ' class="is-on"' : '') + '></i>';
      dotsEl.innerHTML = html;
      Array.prototype.forEach.call(dotsEl.children, function(d, i){
        d.style.cursor = 'pointer';
        d.addEventListener('click', function(){ cur = i; paintRevs(); });
      });
    }
    paintRevs();
    setInterval(function(){ cur = (cur + 1) % pages.length; paintRevs(); }, 7000);
  }

  /* ---- sticky bar --------------------------------------------------------- */
  var sticky = root.querySelector('[data-co-sticky]');
  var pbar = document.getElementById('PBarNextFrameWrapper');
  if(sticky && pbar) sticky.style.bottom = pbar.getBoundingClientRect().height + 'px';
  var bundleBtn = root.querySelector('[data-co-bundle]');
  if(bundleBtn) bundleBtn.addEventListener('click', function(){
    var t = root.querySelector('[data-co-tier]');
    if(t) t.scrollIntoView({behavior: 'smooth', block: 'center'});
  });

  paint();
})();
